import Client from './Clients/AxiosClient'

export default {
  getBasePricing () {
    return Client.get('customer_pricing_bases')
      .then(response => response.data)
  },
  getDirectPricing () {
    return Client.get('direct_school_pricings')
      .then(response => response.data)
  },
  getPricing (accountId, schoolYear) {
    return Client.get(`customer_pricings?accountId=${accountId}&year=${schoolYear}`)
      .then(response => response.data)
  },
  getBindingPrice (designation, schoolYear) {
    return Client.get(`binding_prices?designation=${designation}&year=${schoolYear}`)
      .then(response => response.data)
  },
  getShippingGrids () {
    return Client.get('shipping_prices')
      .then(response => response.data)
  },
  getPricingItems (schoolYear, accountType) {
    return Client.get(`pricing_items?year=${schoolYear}&type_items=${accountType}`)
      .then(response => response.data)
  }
}
